import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";

export const useIsOnMobile = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme?.breakpoints?.down('md'));

    return isMobile
}